import { Predicate } from '../../types/Predicate';

/**
 * Compose predicate functions with AND.
 */
export function and<T>(...predicates: Array<Predicate<T>>): Predicate<T> {
    return (value: T) => predicates.every((predicate) => predicate(value));
}
